<template>
  <div ref="pageView" class="page-view">
    <application-content
      ref="applicationContent"
      :pageType="bookingStatus == 0 ? 'draftEdit' : 'edit'"
    ></application-content>
  </div>
</template>

<script>
// api
import { getBookingDetailById } from "@/api/businessApplication";
// components
import applicationContent from "./components/applicationContent.vue";
export default {
  components: { applicationContent },
  data() {
    return {
      bookingId: "",
      bookingStatus: "",
      loading: false,
      detailData: {},
    };
  },
  created() {
    this.bookingId = Number(this.$route.query.bookingId);
    this.bookingStatus = this.$route.query.bookingStatus;
    this.getDetail();
  },
  mounted() {},
  methods: {
    // 查询详情数据
    async getDetail() {
      try {
        this.loading = true;
        let res = await getBookingDetailById({ bookingId: this.bookingId });
        if (res.code) {
          this.detailData = res.result;
          this.$refs.applicationContent.init(this.detailData);
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.page-view {
  height: 100%;
  overflow: auto;
}
</style>
